import React, {useContext} from 'react';
import {ProductContext} from "../../../../pages/ProductStencil";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {Bundle} from "./Bundle";
import {isLoggedIn} from "../../../../../data/user.model";

export const Bundles = () => {
    if (!isLoggedIn()) {
        return null;
    }

    const {PromotionStructure: bundles, activeProductIndex} = useContext(ProductContext);
    const bundlesData = bundles.map(({Promotion}) => Promotion).filter(({Option}) => !!Option.BundleId);

    if (!bundlesData || bundlesData.length === 0) {
        return null;
    }

    const translate = useI18N();

    return (
        <>
            <div className="pdp-bundles">
                <h2 className="pdp-bundles__title">{translate("Recommended products")}</h2>
                <div className="pdp-bundles__content">
                    {bundlesData.map(({Option}) => <Bundle Option={Option} />)}
                </div>
            </div>
        </>
    );
}
